<template>
  <base-material-card color="transparent" no-padding>
    <v-list two-line :three-line="$vuetify.breakpoint.smAndDown" color="transparent">
      <v-list-item>
        <v-list-item-avatar size="75">
          <img class="profilePicture" :src="supportsObjectFit ? profilePicture : ''" :style="profilePictureStyle" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Posted by</v-list-item-subtitle>
          <v-list-item-title class="display-2">{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle v-if="displayContactDetails">
            {{ user.phone ? `${user.phone} | ` : ''
            }}{{
              user.additionalPhones && user.additionalPhones.length > 0
                ? `${user.additionalPhones.join(' | ')} | `
                : ''
            }}{{ user.email }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <slot name="user-actions" />
      </v-list-item>
    </v-list>
  </base-material-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserDetails',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      supportsObjectFit: false,
    };
  },
  computed: {
    ...mapState('video', {
      displayContactDetails: state => state.current.displayContactDetails,
    }),
    profilePicture() {
      return this.user.profilePicture || require('~/assets/images/silhouette.png');
    },
    profilePictureStyle() {
      if (!this.supportsObjectFit) {
        return `background-image: url(${this.profilePicture}); background-size: cover; background-position: 50% 50%; background-color: lightgray`;
      }

      return 'object-fit: cover; background-color: lightgray';
    },
  },
  mounted() {
    this.supportsObjectFit = 'objectFit' in document.documentElement.style;
  },
};
</script>
